<!-- <div #upElement></div> -->

<div class="container mt-4 d-flex flex-row justify-content-between">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="pointer">

                <!-- [routerLink]="['/admin/loan/loan-list']" -->
                <a (click)="goBack()">
                    <span><img src="../../../assets/images/leftArrow.svg" class="me-2" alt=""></span>
                </a>
            </li>
            <li class="breadcrumb-item pointer" [routerLink]="['/admin/loan/pdf']">Application Pdf View<span *ngIf="pdfData" style="color: gray;">/ {{pdfData?.applicationNumber}}</span> </li>
        </ol>
    </nav>


    <div class="scroll-container">
        <div class="print_box pointer d-flex align-items-center justify-content-center" mat-icon-button (click)="scrollToBottom()">
            <mat-icon>arrow_downward</mat-icon>
        </div>
    </div>
</div>
 <div class="d-flex justify-content-between" style="margin-left: 25px;">
        <button class="btn reject_btn text-white" *ngIf="isSanction" (click)="openRejectDialog(dataFromLoanList)">
      <span><img src="/assets/images/closeIcon-shg.svg" class="img-fluid" alt="Close" /></span>
      Reject</button>
        <div class="d-flex">
            <div class="print_box pointer d-flex align-items-center justify-content-center me-3" (click)="downloadPDF()" matTooltip="Download">
                <img src="/assets/images/download-shg.svg" class="img-fluid" alt="Download" />
            </div>
            <div class="print_box pointer d-flex align-items-center justify-content-center" (click)="printPage()" matTooltip="Print">
                <img src="/assets/images/printIcon-shg.svg" class="img-fluid" alt="Print" />
            </div>

            <button class="btn sanction_Btn text-white text-uppercase br-4" *ngIf="isSanction" (click)="openSanctionDialog(dataFromLoanList)">Sanction the proposal</button>
        </div>
    </div>



<div class="container-fluid" id="no-print">
    <!-- <div *ngIf="isLoading" class="loader">Loading...</div> -->
    <app-loader [isLoading]="isLoading"></app-loader>

    <div id="htmlData">

        <div class="card my-4 page-break-avoid">
            <div class="card-body">
                <h1 class="fs-33 fw-600 text-center mb-1">Acknowledgement</h1>
                <p class="fs-16 fw-400 color-grey text-center">(To be handed over to SHG after submission of the Application Form)
                </p>

                <div class="card border-0 detailCard">
                    <div class="card-body pb-0">
                        <h6 class="fs-16 fw-600 mb-3">Received the following Application form for loan</h6>
                        <div class="d-flex flex-wrap">
                            <div class="commonDetail_div">
                                <div class="fs-12 fw-400 color-grey">Name of SHG</div>
                                <div class="fs-14 fw-400 ">{{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}})</div>
                            </div>
                            <div class="commonDetail_div">
                                <div class="fs-12 fw-400 color-grey">Address</div>
                                <div class="fs-14 fw-400 ">District-{{pdfData['districtName']}}, Grampanchayat- {{pdfData['grampanchayatName']}} , Village-{{pdfData['villageName']}}
                                </div>
                            </div>
                            <div class="commonDetail_div">
                                <div class="fs-12 fw-400 color-grey">Application No</div>
                                <div class="fs-14 fw-400 ">{{pdfData['applicationNumber']}}</div>
                            </div>
                            <div class="commonDetail_div">
                                <div class="fs-12 fw-400 color-grey">Saving Account Number</div>
                                <div class="fs-14 fw-400 ">{{pdfData['accountNumber']}}</div>
                            </div>
                            <div class="commonDetail_div">
                                <div class="fs-12 fw-400 color-grey">Date of Receipt of Hard Copy of Application by branch
                                </div>
                                <div class="fs-14 fw-400 ">{{pdfData['formationDate'] | date:'shortDate'}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="fs-12 fw-400 mb-1">(Signature)</div>
                <div class="fs-12 fw-400 mb-1 text-uppercase"><span class="color-grey">Branch:</span> {{pdfData['reviewedBranchName']}}
                </div>
                <div class="fs-12 fw-400 mb-1 text-uppercase"><span class="color-grey">Bank Name:</span> {{pdfData['reviewedBankName']}}
                </div>
                <div class="fs-12 fw-400 mb-1"><span class="color-grey">Date:</span> {{pdfData?.formationDate | date :'dd/MM/YY'}}
                </div>

                <hr>
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="fs-16 fw-500">Bank's Name & Logo {{pdfData?.reviewedBankName}} </span>
                    <div class="fs-14 fw-400">Form No: <span class="form_no d-inline-block">{{pdfData?.applicationNumber}}</span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3">
                        <div class="card h-100 mb-3">
                            <div class="card-body">
                                <div class="d-flex flex-column mb-4">
                                    <span class="fs-12 fw-400 color-grey">Bank</span>
                                    <span class="fs-14 fw-500 text-uppercase">{{pdfData['reviewedBankName']}}</span>
                                </div>
                                <div class="d-flex flex-column mb-4">
                                    <span class="fs-12 fw-400 color-grey">Branch</span>
                                    <span class="fs-14 fw-500 text-uppercase">{{pdfData['reviewedBranchName']}}</span>
                                </div>
                                <div class="d-flex flex-column">
                                    <span class="fs-12 fw-400 color-grey">SB Account No.</span>
                                    <span class="fs-14 fw-500 text-uppercase">{{pdfData['accountNumber']}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div class="table-responsive">
                            <table class="table table-bordered m-0">
                                <tbody>
                                    <tr>
                                        <td colspan="2" class="fs-16 fw-600 text-center align-middle">For official use only
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fs-14 fw-500 align-middle">Customer Id:</td>
                                        <td class="fs-14 fw-500 align-middle">Date of Sanction:</td>
                                    </tr>
                                    <tr>
                                        <td class="fs-14 fw-500 align-middle">Loan A/C no:</td>
                                        <td class="fs-14 fw-500 align-middle">Sanction Amount in RS.</td>
                                    </tr>
                                    <tr>
                                        <td class="fs-14 fw-500 align-middle">Loan type <br> (CCl/TL) Cash Credit Limit/Term Loan
                                        </td>
                                        <td class="fs-14 fw-500 align-middle">Loan Terms <br> (in case of <br> Term Loan)</td>
                                    </tr>
                                    <tr>
                                        <td class="fs-14 fw-500 align-middle">Product Code:</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <hr>
                <div class="card border-0 bg-f5 br-4">
                    <div class="card-body pb-0">
                        <h6 class="fs-16 fw-600 mb-3">Self Help Group Loan Application Form</h6>
                        <div class="row">
                            <div class="col-md-4 common_margin">
                                <div class="fs-12 fw-400 color-grey">Name of SHG</div>
                                <div class="fs-14 fw-400 ">{{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}})</div>
                            </div>
                            <div class="col-md-4 common_margin">
                                <div class="fs-12 fw-400 color-grey">Date of Formation</div>
                                <div class="fs-14 fw-400 ">{{ pdfData?.formationDate | date : 'dd/MM/YY' }}
                                </div>
                            </div>
                            <div class="col-md-4 common_margin">
                                <div class="fs-12 fw-400 color-grey">Number of SHG members</div>
                                <div class="fs-14 fw-400 "> {{pdfData['memberCount']}} </div>
                            </div>
                            <div class="col-md-4 common_margin">
                                <div class="fs-12 fw-400 color-grey">Address</div>
                                <div class="fs-14 fw-400 ">District-{{pdfData['districtName']}}, Grampanchayat-{{pdfData['grampanchayatName']}} , Village-{{pdfData['villageName']}}
                                </div>
                            </div>
                            <div class="col-md-4 common_margin">
                                <div class="fs-12 fw-400 color-grey">SB A/C No</div>
                                <div class="fs-14 fw-400 "> {{pdfData['accountNumber']}} </div>
                            </div>
                            <div class="col-md-4 common_margin">
                                <div class="fs-12 fw-400 color-grey">Loan A/c No (if any)</div>
                            </div>
                            <div class="col-md-4 common_margin">
                                <div class="fs-12 fw-400 color-grey">Supporting Agency (if any)</div>
                                <div class="fs-14 fw-400 ">NRLM</div>
                            </div>
                            <div class="col-md-4 common_margin">
                                <div class="fs-12 fw-400 color-grey">Application for Loan Cycle {{pdfData?.appliedFor}}
                                </div>
                                <div class="fs-14 fw-400 ">{{ pdfData?.applicationType == '1' ? 'Fresh' : (pdfData?.applicationType == '2' ? 'Renewal' : 'Enhancement') }}</div>
                            </div>
                            <div class="col-md-4 common_margin">
                                <div class="fs-12 fw-400 color-grey">Bank Name</div>
                                <div class="fs-14 fw-400 ">{{pdfData['bankName']}}</div>
                            </div>
                            <div class="col-md-4 common_margin">
                                <div class="fs-12 fw-400 color-grey">Branch Name</div>
                                <div class="fs-14 fw-400 ">{{pdfData['bankBranchName']}}</div>
                            </div>
                            <div class="col-md-4 common_margin">
                               <div class="fs-12 fw-400 color-grey">Date of opening of Bank S/B A/C: </div>
                                <div class="fs-14 fw-400 ">{{pdfData?.mcpDate | date: 'dd/MM/YY'}}</div>
                             </div>

                    </div>
                </div>
                <hr>
                <h6 class="fs-16 fw-600 mb-3 text-center">Self Help Group Loan Application Form</h6>
                <div class="fs-12 fw-500 mb-1">To:</div>
                <div class="fs-12 fw-500 mb-1 text-uppercase">The Branch Manager</div>
                <div class="fs-12 fw-500 mb-1 text-uppercase">{{pdfData['reviewedBankName']}}</div>
                <div class="fs-12 fw-500 mb-3">{{pdfData['reviewedBranchName']}}</div>

                <div class="fs-14 fw-400 mb-3">Dear Madam/Sir,</div>

                <h6 class="fs-16 fw-600 mb-3 text-center">Sub:-Application for credit linkage</h6>

                <div class="row page-break d-flex flex-wrap">
                    <div class="col-md-4" *ngFor="let member of headMembers">
                        <div class="card border-db mb-3">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="d-flex flex-column mb-2">
                                            <span class="fs-12 fw-400 color-grey">Name</span>
                                            <span class="fs-14 fw-500 text-uppercase"> {{member['memberName']}} </span>
                                        </div>
                                        <div class="d-flex flex-column mb-2">
                                            <span class="fs-12 fw-400 color-grey">Designation</span>
                                            <span class="fs-14 fw-500">{{member['leader']}}</span>
                                        </div>
                                        <div class="d-flex flex-column mb-2">
                                            <span class="fs-12 fw-400 color-grey">Address</span>
                                            <span class="fs-14 fw-500 text-uppercase">District- {{pdfData?.districtName}}, Block-
                        {{pdfData?.blockName}}, Grampanchayat- {{pdfData?.grampanchayatName}}</span>
                                        </div>
                                        <div class="d-flex flex-column mb-2">
                                            <span class="fs-12 fw-400 color-grey">Mobile</span>{{member?.mobileNumber ? member.mobileNumber : 'N/A'}}
                                        </div>
                                        <div class="d-flex flex-column mb-2">
                                            <span class="fs-12 fw-400 color-grey">Saving Bank A/c No</span> {{ pdfData?.bankAccountNo}}
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="place_photo fs-12 fw-400 d-flex flex-column align-items-center justify-content-center">
                                            <img [src]="member?.photo ? member?.photo : '../../../../assets/images/profilePicTemplate.jpg'" alt="N/A" style="width: 100px; height: 150px;">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div ></div> -->

                <div class="list_section">
                    <ol class="list">
                        <li class="fs-14 fw-400 mb-1" *ngFor="let item of list">{{item?.points}}</li>
                    </ol>
                    <div class="fs-14 fw-400">Yours faithfully,</div>
                </div>

                <div class="d-flex justify-content-between mb-2" *ngIf="headMembers.length > 0">
                    <div class="d-flex flex-column" *ngFor="let item of headMembers;">
                        <div class="fs-14 fw-400 text-uppercase">{{ item?.memberName }}</div>
                        <div class="fs-12 fw-400 color-grey">({{item?.leader}})</div>
                    </div>
                    <!-- <div class="d-flex flex-column">
                        <div class="fs-14 fw-400 text-uppercase">RAJKUMARI</div>
                        <div class="fs-12 fw-400 color-grey">(Secretary)</div>
                    </div>
                    <div class="d-flex flex-column">
                        <div class="fs-14 fw-400 text-uppercase">GUDDI BAI</div>
                        <div class="fs-12 fw-400 color-grey">(Treasurer)</div>
                    </div> -->
                </div>
                <div class="fs-14 fw-400">[Signature of Authorized Representatives of SHG with Seal]</div>
                <hr>
                
               <br/>
               <br/>
                <div class="card border-0 bg-f5 br-4">
                    <div class="card-body pb-0">
                        <h6 class="fs-16 fw-600 mb-3">Resolution by SHG for taking loan from bank</h6>
                        <div class="row">
                            <div class="col-md-3 common_margin">
                                <div class="fs-12 fw-400 color-grey">Name of SHG</div>
                                <div class="fs-14 fw-400 ">{{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}})</div>
                            </div>
                            <div class="col-md-6 common_margin">
                                <div class="fs-12 fw-400 color-grey">Address</div>
                                <div class="fs-14 fw-400 ">District- {{ pdfData?.districtName }}, Grampanchayat- {{ pdfData?.grampanchayatName }}, Village- {{ pdfData?.villageName }} </div>
                            </div>
                            <div class="col-md-3 common_margin">
                                <div class="fs-12 fw-400 color-grey">Date of Formation</div>
                                <div class="fs-14 fw-400 ">{{ pdfData?.formationDate | date: 'dd/MM/YY' }}
                                </div>
                            </div>
                            <div class="col-md-3 common_margin">
                                <div class="fs-12 fw-400 color-grey">Total no of Members</div>
                                <div class="fs-14 fw-400 ">{{ pdfData?.memberCount }}</div>
                            </div>
                            <div class="col-md-6 common_margin">
                                <div class="fs-12 fw-400 color-grey">Name of Facilitating Agency</div>
                                <div class="fs-14 fw-400 ">NRLM</div>
                            </div>
                        </div>

                    </div>
                </div>
              
                <hr>


                <!-- Done till Here -->

               <h6 class="fs-16 fw-600 mb-3 text-center">Resolution of taking loan from bank</h6>

<p class="fs-14 fw-400">
  Today on {{ pdfData?.mcpDate | date: 'dd/MM/YY' }}, at the meeting of {{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}}) at District-{{pdfData?.districtName}}, Grampanchayat-{{pdfData?.grampanchayatName}}, Village-{{pdfData?.villageName}}, in presence of all its members, it is resolved that our {{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}}) will seek loan of Rs. {{ pdfData?.mcpTotalLoanAmount }} ({{ amountInWords }}) from {{ pdfData?.reviewedBankName }}.
  It has also been further agreed that 
  <ng-container *ngFor="let member of headMembers; let i = index">
    <ng-container *ngIf="member?.memberName && member?.leader; else notAppointed">
     <b> {{ member.memberName }} ({{ member.leader }})   <span *ngIf="i < headMembers.length - 1">
      {{ i === headMembers.length - 2 ? ' & ' : ', ' }}
    </span></b>
    </ng-container>
    <ng-template #notAppointed>
      {{
        i === 0 ? 'President not appointed' :
        i === 1 ? 'Secretary not appointed' :
        i === 2 ? 'Treasurer not appointed' :
        'Member not appointed'
      }}   <span *ngIf="i < headMembers.length - 1">
      {{ i === headMembers.length - 2 ? ' & ' : ', ' }}
    </span>
    </ng-template>
  </ng-container>
  will sign all the necessary documents related to the loan application to the bank on behalf of the {{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}}). We also authorize them to execute the acknowledgment of debts as may be required by the Bank. We all members hereby agree to the above decision.
</p>
      <!-- Table -->

                <!-- <app-common-table></app-common-table> -->
                <div class="table-responsive">
                    <table class="table table-borderless table-hover">
                        <thead style="text-align: left;">
                            <tr>
                                <th>S.No.</th>
                                <th>SHG Member Name</th>
                                <th>Father / Husband Name</th>
                                <th>Gender</th>
                                <th>Signature/Thumb impression</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="border-bottom" *ngFor="let data of membersList; let rowIndex = index">
                                <td>{{rowIndex+1}}</td>
                                <td>{{data?.memberName}}</td>
                                <td>{{data?.belongingName}}</td>
                                <td>{{data?.gender}}</td>
                                <td>{{data?.signature}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- <app-loan-table [header]="resolutionHeader" [tableData]="pdfData['members']"></app-loan-table> -->

                <div class="d-flex justify-content-between mb-2" *ngIf="headMembers.length > 0">
                    <div class="d-flex flex-column" *ngFor="let member of headMembers">
                        <div class="fs-14 fw-400 text-uppercase">{{member?.memberName}}</div>
                        <div class="fs-12 fw-400 color-grey">({{member?.leader}})</div>
                    </div>
                    <!-- <div class="d-flex flex-column">
                    <div class="fs-14 fw-400 text-uppercase">RAJKUMARI</div>
                    <div class="fs-12 fw-400 color-grey">(Secretary)</div>
                </div>
                <div class="d-flex flex-column">
                    <div class="fs-14 fw-400 text-uppercase">GUDDI BAI</div>
                    <div class="fs-12 fw-400 color-grey">(Treasurer)</div>
                </div> -->
                </div>
                <br/>
                <br/>
                <br/>
                <div class="fs-14 fw-400 mb-2">Details of Member</div>
                <div class="fs-14 fw-400  ">Seal of Self Help Group</div>
                <hr>
                <br/>
                <div class="card border-0 bg-f5 br-4">
                    <div class="card-body pb-0 ">
                        <h6 class="fs-16 fw-600 mb-3">Resolution by SHG for taking loan from bank</h6>
                        <div class="row">
                            <div class="col-md-3 common_margin">
                                <div class="fs-12 fw-400 color-grey">Name of SHG</div>
                                <div class="fs-14 fw-400 ">{{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}})</div>
                            </div>
                            <div class="col-md-6 common_margin">
                                <div class="fs-12 fw-400 color-grey">Address</div>
                                <div class="fs-14 fw-400 ">District-{{pdfData?.districtName}}, Grampanchayat-{{pdfData?.grampanchayatName}} , Village-{{pdfData?.villageName}}
                                </div>
                            </div>
                            <div class="col-md-3 common_margin">
                                <div class="fs-12 fw-400 color-grey">Date of Formation</div>
                                <div class="fs-14 fw-400 ">{{ pdfData?.formationDate | date: 'dd/MM/YY' }}
                                </div>
                            </div>
                            <div class="col-md-3 common_margin">
                                <div class="fs-12 fw-400 color-grey">Total no of Members</div>
                                <div class="fs-14 fw-400 ">{{pdfData?.memberCount}}</div>
                            </div>
                        </div>

                    </div>
                </div>
                <hr>
                <h6 class="fs-16 fw-600 mb-2 text-center">Member-wise details of proposed investment, sources of fund & resultant Net Surplus of the family</h6>

                <div class="card rounded-3 border-0 mt-2" *ngIf="pdfData?.memberMcpDetail !== null">
                    <div class="card-body">
                        <div class="table-responsive">
                           <table class="table table-borderless">
  <thead style="text-align: left;">
    <tr>
      <th>S.No</th>
      <th>Name</th>
      <th>Purpose of Investment</th>
      <th>Amount of loan Required from SHG (Rs.)</th>
      <th>Total annual income from various sources</th>
      <th>Total annual Expenditure</th>
      <th>Annual repayment of Proposal Loan & Existing Loan (Rs.)</th>
      <th>Priority</th>
      <th>Training Required</th>
    </tr>
  </thead>

  <tbody>
    <tr class="border-bottom" *ngFor="let member of pdfData?.memberMcpDetail; let i = index;">
      <td>{{ i + 1 }}</td>
      <td>{{ member?.memberName }} ({{ member?.belongingName || '-' }})</td>
      <td>{{ member?.loanPurposeName || '-' }}</td>
      <td>{{ member?.loanAmount || 0 }}</td>
      <td>{{ member?.totalAnnualIncome || 0 }}</td>
      <td>{{ member?.totalAnnualExpenses || 0 }}</td>
      <td>{{ member?.annualRepayment || 0 }}</td>
      <td>{{ member?.priority || '-' }}</td>
      <td>{{ member?.trainingRequired || '-' }}</td>
    </tr>
  </tbody>
</table>

                        </div>
                    </div>

                </div>

                <h6 class="fs-16 fw-600 mb-2 text-center text-uppercase">INTER-SE AGREEMENT TO BE EXECUTED BY THE MEMBERS OF
                    <br> THE SELF HELP GROUP
                </h6>
                <div class="fs-14 fw-400">This Agreement made on {{pdfData?.mcpDate | date: 'dd/MM/YY'}} Between</div>

                <!-- Table -->
                <div class="card rounded-3 border-0 mt-2">
                    <div class="card-body">

                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <thead style="text-align: left;">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Name</th>
                                        <th>Father / Husband Name</th>
                                        <th>Gender</th>
                                        <th>Age</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <ng-container *ngFor="let member of membersList; let i = index;">
  
  <!-- Insert an empty row before the 7th item (i === 6) -->
  <tr *ngIf="i === 6">
    <td colspan="5" style="height: 10px;"></td> <!-- empty row with spacing -->
  </tr>

  <!-- Normal row -->
  <tr class="border-bottom">
    <td>{{ i + 1 }}</td>
    <td>{{ member?.memberName }}</td>
    <td>{{ member?.belongingName }}</td>
    <td>{{ member?.gender }}</td>
    <td>{{ member?.age }}</td>
  </tr>

</ng-container>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <p class="fs-14 fw-400">who are members of the {{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}}) group, hereinafter referred to collectively as "The Self Help Group (SHG) Members " which expression shall,
                    unless repugnant to the context or meaning, include every members of the said SHG and their respective legal heirs executors and administrators.</p>
                <p class="fs-14 fw-400">who are members of the {{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}}) group, hereinafter referred to collectively as "The Self Help Group (SHG) Members " which expression shall,
                    unless repugnant to the context or meaning, include every members of the said SHG and their respective legal heirs executors and administrators.WHEREAS all SHG members are residents of District-{{pdfData?.districtName}}, Grampanchayat-{{pdfData?.grampanchayatName}}
                    , Village-{{pdfData?.villageName}} and are known to each other.WHEREAS the SHG members above named have joined voluntarily together and formed the SHG with intent to carry on savings and credit and other economic activities for mutual
                    benefit subject to the terms and conditions hereinafter appearing:</p>
                <p class="fs-14 fw-400">NOW THEREFORE THIS AGREEMENT WITNESSETH THAT:</p>

   <ol>
  <ng-container *ngFor="let item of witnessethList; let i = index">
    <ng-container *ngIf="i === 13"><br /><br/></ng-container>
    <li class="fs-14 fw-400 mb-1">{{ item?.list }}</li>
  </ng-container>
</ol>


                <p class="fs-14 fw-400">IN WITNESS WHEREOF the aforesaid members of the SHG have set their respective hands hereunto at the place District-{{pdfData?.districtName}}, Grampanchayat-{{pdfData?.grampanchayatName}} , Village- {{pdfData?.villageName}} and on {{pdfData?.mcpDate
                    | date: 'dd/MM/YY'}} first herein appearing.</p>

                <!-- Table -->
                <div class="card rounded-3 border-0 mt-2">
                    <div class="card-body">

                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <thead style="text-align: left;">
                                    <tr>
                                        <th>S.No</th>
                                        <th>SHG Member Name</th>
                                        <th>Signature/ Thumb impression</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr class="border-bottom" *ngFor="let member of membersList; let i = index;">

                                        <td>{{ i + 1 }}</td>
                                        <td>{{member?.memberName}}</td>
                                        <td></td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="fs-14 fw-600 mb-2">WITNESSES:</div>
                <ol class="list">
                    <li class="mb-2"></li>
                    <li class="mb-2"></li>
                </ol>

                <span class="fs-14 fw-400">(Note: The SHG shall not consist more than 12 persons.)</span>
                <hr>
                <!-- <br/>
              
                <br/> -->
                  <br/>
                  <br/>
                <div class="row ">
                    <div class="col-md-6">
                        <h6 class="fs-16 fw-600">Expenditure</h6>
                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <thead>
                                    <tr class="align-middle">
                                        <!-- <th>S.No.</th> -->
                                        <th>Particulars</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="align-middle border-bottom" *ngFor="let item of expenditureArr; let i = index;">
                                        <!-- <td>{{ i+1 }}</td> -->
                                        <td>{{ item?.headName }}</td>
                                        <td>
                                            <p>{{ item?.amount }}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    
                    <div class="col-md-6">
                        <h6 class="fs-16 fw-600">Income</h6>
                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <thead>
                                    <tr class="align-middle">
                                        <!-- <th>S.No.</th> -->
                                        <th>Particulars</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="align-middle border-bottom" *ngFor="let item of incomeArr; let i = index;">
                                        <!-- <td>{{ i+1 }}</td> -->
                                        <td>{{ item?.headName }}</td>
                                        <td>
                                            <p>{{ item?.amount }}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card mb-3 total_card border-0">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="fs-14 fw-400 me-3">Total</div>
                                            <span class="fs-14 fw-400">{{ totalExpenditure }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="fs-14 fw-400 me-3">Total</div>
                                            <span class="fs-14 fw-400">{{ totalIncome }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr>


                <div class="fs-16 fw-600 mb-2 text-center">Balance sheet as on {{ pdfData?.incExpDateTo | date: 'dd/MM/YY' }}
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <h6 class="fs-16 fw-600">Liabilities</h6>
                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <thead>
                                    <tr class="align-middle">
                                        <!-- <th>S.No.</th> -->
                                        <th>Particulars</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="align-middle border-bottom" *ngFor="let item of liabilitiesArr; let i = index;">
                                        <!-- <td>{{ i+1 }}</td> -->
                                        <td>{{ item?.headName }}</td>
                                        <td>
                                            <p>{{ item?.amount }}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h6 class="fs-16 fw-600">Assets</h6>
                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <thead>
                                    <tr class="align-middle">
                                        <!-- <th>S.No.</th> -->
                                        <th>Particulars</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="align-middle border-bottom" *ngFor="let item of assetsArr; let i = index;">
                                        <!-- <td>{{ i+1 }}</td> -->
                                        <td>{{ item?.headName }}</td>
                                        <td>
                                            <p>{{ item?.amount }}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card mb-3 total_card border-0">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="fs-14 fw-400 me-3">Total</div>
                                            <span class="fs-14 fw-400">{{ totalLiabilities }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="fs-14 fw-400 me-3">Total</div>
                                            <span class="fs-14 fw-400">{{ totalAssets }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>

                <div class="fs-12 fw-400 mb-4">(Amount in Words .)</div>

                <p class="fs-12 fw-500 mb-5">We certify that the above statement is true and can be verified from the books of accounts maintained by our Self Help Group.</p>

                <div class="d-flex justify-content-around mb-2 border-db br-4 profession_card" *ngIf="headMembers.length > 0">
                    <div class="d-flex flex-column align-items-center" *ngFor="let member of headMembers">
                        <div class="fs-14 fw-400 text-uppercase mb-1">{{member?.memberName}}</div>
                        <div class="fs-12 fw-400 color-grey">({{member?.leader}})</div>
                    </div>
                    <!-- <div class="d-flex flex-column align-items-center">
                    <div class="fs-14 fw-400 text-uppercase mb-1">RAJKUMARI</div>
                    <div class="fs-12 fw-400 color-grey">(Secretary)</div>
                </div>
                <div class="d-flex flex-column align-items-center">
                    <div class="fs-14 fw-400 text-uppercase mb-1">GUDDI BAI</div>
                    <div class="fs-12 fw-400 color-grey">(Treasurer)</div>
                </div> -->
                </div>
                <hr>

                <h6 class="fs-20 fw-600 mb-2 text-center">For Official Use Only</h6>
                <div class="fs-16 fw-500 mb-4 text-center">Format 1: SHG Grading format for Fresh Linkage(( Term loan and CCL/DL))
                </div>

                <div class="fs-14 fw-500 mb-2">A.Basic Information:</div>
                <div class="fs-14 fw-400 color-grey mb-2">Name of SHG: <span class="color-0e fw-500">{{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}})</span></div>
                <div class="fs-14 fw-400 color-grey mb-2">Address: <span class="color-0e fw-500">District-{{pdfData?.districtName}},
            Grampanchayat-{{pdfData?.grampanchayatName}} , Village-{{pdfData?.villageName}}</span></div>
                <div class="fs-14 fw-400 color-grey mb-2">Date of formation of the SHG: <span class="color-0e fw-500">{{pdfData?.formationDate | date: 'dd/MM/YY'}}</span></div>
                <div class="fs-14 fw-400 color-grey mb-2">Date of opening of Bank S/B A/C: <span class="color-0e fw-500">{{pdfData?.mcpDate | date: 'dd/MM/YY'}}</span></div>
                <div class="fs-14 fw-400 color-grey mb-3">Period considered for Grading: From <span class="color-0e fw-500">{{pdfData?.incExpDateFrom | date: 'dd/MM/YY'}} <span
              class="color-grey fw-400">to</span> {{pdfData?.incExpDateTo | date: 'dd/MM/YY'}} .</span>
                </div>

                <div class="d-flex justify-content-between mb-2">
                    <div class="fs-14 fw-500">B.Details of Grading /Evaluation Exercise:</div>
                    <span class="fs-14 fw-400">(Usually last 6 months)</span>
                </div>

                <div class="card rounded-3 border-0 mt-2">
                    <div class="card-body">

                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <thead style="text-align: left;">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Indicator</th>
                                        <th>Allocated Marks</th>
                                        <th>Formula for determining Marks</th>
                                        <th>Marks obtained</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr class="border-bottom">
                                        <td>1</td>
                                        <td>Regularity of Meeting:</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                  <br/>
                                    <tr class="border-bottom">
                                        <td>a</td>
                                        <td>Regularity of holding meetings by SHG</td>
                                        <td>10</td>
                                        <td>No. of meetings held X10 No. of meetings required to be held as per rule of SHG</td>
                                        <td></td>
                                    </tr>
                                    
                                    <tr class="border-bottom">
                                        <td>b</td>
                                        <td>Regularity of Attendance of members in the meetings</td>
                                        <td>10</td>
                                        <td>Average no. of members attended the meetings X10 Total no. of members of the SHG</td>
                                        <td></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td>2</td>
                                        <td>Regularity of Savings by members</td>
                                        <td>10</td>
                                        <td>Amount of savings deposited by the members X 10 Amount of savings required to be deposited as per rule of SHG</td>
                                        <td></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td>3</td>
                                        <td>*Velocity of Lending to members from Group Corpus</td>
                                        <td>20</td>
                                        <td>
                                            More than 1.5: 20 <br> More than 1.0 up to 1.5: 15 <br> More than 0.5 up to 1.0: 10 <br> More than 0.2 up to 0.5: 5 <br> Upto 0.2: 0
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td>4</td>
                                        <td>Regularity in Repayment of loan by members</td>
                                        <td>20</td>
                                        <td>
                                            Amount of recovery against Demand X 20 <br> Amount of Demand (required to be paid as per repayment schedule)
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td>5</td>
                                        <td>Updated Record keeping:</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <ul class="list">
                    <li class="fs-14 fw-500">A Grade: 80 or more marks</li>
                    <li class="fs-14 fw-500">B Grade: 70-79 marks</li>
                    <li class="fs-14 fw-500">C Grade: 60-69 marks</li>
                    <li class="fs-14 fw-500">D Grade: less than 60 marks</li>
                </ul>

                <div class="fs-14 fw-400">Only A & B graded SHGs are to be considered for credit linkage</div>
                <hr>

                <h6 class="fs-16 fw-500 text-center mb-4">Format 2: SHG Grading format for Repeat Linkage (Cash Credit/Term Loan)</h6>

                <div class="fs-14 fw-500 mb-2">A.Basic Information:</div>
                <div class="fs-14 fw-400 color-grey mb-2">Name of SHG: <span class="color-0e fw-500">{{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}})</span></div>
                <div class="fs-14 fw-400 color-grey mb-2">Address: <span class="color-0e fw-500">District-{{pdfData?.districtName}},
            Grampanchayat-{{pdfData?.grampanchayatName}} , Village-{{pdfData?.villageName}}</span></div>
                <div class="fs-14 fw-400 color-grey mb-2">Date of formation of the SHG: <span class="color-0e fw-500">{{pdfData?.formationDate | date: 'dd/MM/YY'}}</span></div>
                <div class="fs-14 fw-400 color-grey mb-2">Date of opening of Bank S/B A/C: <span class="color-0e fw-500">{{pdfData?.mcpDate | date: 'dd/MM/YY'}}</span></div>
                <div class="fs-14 fw-400 color-grey mb-3">Period considered for Grading: From <span class="color-0e fw-500">{{pdfData?.incExpDateFrom | date: 'dd/MM/YY'}} <span
              class="color-grey fw-400">to</span> {{pdfData?.incExpDateTo | date: 'dd/MM/YY'}} .</span>
                </div>

                <div class="d-flex justify-content-between mb-2">
                    <div class="fs-14 fw-500">B.Details of Grading /Evaluation Exercise:</div>
                    <span class="fs-14 fw-400">(Usually last 12 months)</span>
                </div>

                <div class="card rounded-3 border-0 mt-2">
                    <div class="card-body">

                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <thead style="text-align: left;">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Indicator</th>
                                        <th>Allocated Marks</th>
                                        <th>Formula for determining Marks</th>
                                        <th>Marks obtained</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr class="border-bottom">
                                        <td>1</td>
                                        <td>Regularity of Meeting:</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                      <br/>
                                    <tr class="border-bottom">
                                        <td>a</td>
                                        <td>Regularity of holding meetings by SHG</td>
                                        <td>10</td>
                                        <td>No. of meetings held X10 No. of meetings required to be held as per rule of SHG</td>
                                        <td></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td>b</td>
                                        <td>Regularity of Attendance of members in the meetings</td>
                                        <td>10</td>
                                        <td>Average no. of members attended the meetings X10 Total no. of members of the SHG</td>
                                        <td></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td>2</td>
                                        <td>Regularity of Savings by members</td>
                                        <td>10</td>
                                        <td>Amount of savings deposited by the members X 10 Amount of savings required to be deposited as per rule of SHG</td>
                                        <td></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td>3</td>
                                        <td>*Velocity of Lending to members from Group Corpus</td>
                                        <td>20</td>
                                        <td>
                                            More than 1.5: 20 <br> More than 1.0 up to 1.5: 15 <br> More than 0.5 up to 1.0: 10 <br> More than 0.2 up to 0.5: 5 <br> Upto 0.2: 0
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td>4</td>
                                        <td>Regularity in Repayment of loan by members</td>
                                        <td>20</td>
                                        <td>
                                            Amount of recovery against Demand X 20 <br> Amount of Demand (required to be paid as per repayment schedule)
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td>5</td>
                                        <td>Updated Record keeping:</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


                <ul class="list">
                    <li class="fs-14 fw-500">A Grade: 80 or more marks</li>
                    <li class="fs-14 fw-500">B Grade: 70-79 marks</li>
                    <li class="fs-14 fw-500">C Grade: 60-69 marks</li>
                    <li class="fs-14 fw-500">D Grade: less than 60 marks</li>
                </ul>
                <div class="fs-14 fw-400">Only A & B graded SHGs are to be considered for credit linkage</div>
                <hr>

                <h6 class="fs-20 fw-500 text-center text-uppercase mb-4">ARTICLES OF LOAN AGREEMENT FOR USE BY BANKS <br> WHILE FINANCING SELF-HELP GROUPS</h6>
                <p class="fs-14 fw-400 mb-3">The Articles of Agreement made on this <span class="text-decoration-underline d-inline-block form_underline"></span> day of <span class="text-decoration-underline d-inline-block form_underline"></span> at <span class="text-decoration-underline d-inline-block form_underline"></span>                    By and Between M/s {{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}}) an unregistered association of persons/individuals having its office at <span class="text-decoration-underline d-inline-block form_underline"></span>                    represented by its authorized representative Shri/Smt. {{headMembers[0]?.memberName ? headMembers[0]?.memberName : 'N/A'}} ({{headMembers[0]?.leader ? headMembers[0]?.leader : 'N/A'}}) Shri/Smt. {{headMembers[1]?.memberName ? headMembers[1]?.memberName
                    : 'N/A'}} ({{headMembers[1]?.leader ? headMembers[1]?.leader : 'N/A'}}) and Shri/Smt. {{headMembers[2]?.memberName ? headMembers[2]?.memberName : 'N/A'}} ({{headMembers[2]?.leader ? headMembers[2]?.leader : 'N/A'}}) (Designation who
                    are fully authorized by all the members of the SHG, ( a copy of such Authorization is annexed hereto and forms part of this agreement), hereinafter referred to as the "Borrower" which expression shall unless repugnant to the subject
                    or context thereof, mean and include members of the unregistered association for the time being, their respective successors, legal heirs, administrators and assigns of the one part and BANK OF INDIA a body corporate constituted under
                    the
                    <span class="text-decoration-underline d-inline-block form_underline"></span> Act, having its Head Office at <span class="text-decoration-underline d-inline-block form_underline"></span> and the Branches, inter-alia, one at <span class="text-decoration-underline d-inline-block form_underline"></span>                    here in after called "the Bank" which expression shall unless repugnant to the subject or context thereof mean and include its successors and assignees of the second part. Whereas the borrower is an unregistered association of persons
                    who have inter-se agreed to help each other as self-help group with a view to developing and ameliorating the socio-economic conditions of their members. Whereas having formed the association as a Self Help Group, the Borrower as per
                    application dated <span class="text-decoration-underline d-inline-block form_underline"></span> made by the said Shri/Smt. {{headMembers[0]?.memberName ? headMembers[0]?.memberName : 'N/A'}} ({{headMembers[0]?.leader ? headMembers[0]?.leader
                    : 'N/A'}}) Shri/Smt. {{headMembers[1]?.memberName ? headMembers[1]?.memberName : 'N/A'}} ({{headMembers[1]?.leader ? headMembers[1]?.leader : 'N/A'}}) and Shri/Smt. {{headMembers[2]?.memberName ? headMembers[2]?.memberName : 'N/A'}}
                    ({{headMembers[2]?.leader ? headMembers[2]?.leader : 'N/A'}}) (Designation, duly authorized to borrow in terms of its resolution dated <span class="text-decoration-underline d-inline-block form_underline"></span> [copy enclosed] requested
                    the Bank to *grant a Term Loan/extend Cash Credit facility* of Rs. {{pdfData?.mcpTotalLoanAmount}} <span class="text-decoration-underline d-inline-block form_underline"></span> up to the limit of Rs. {{pdfData?.totalLoanSanctionLimit}}
                    <span class="text-decoration-underline d-inline-block form_underline"></span> (Rupees <span class="text-decoration-underline d-inline-block form_underline"></span> only) for on-lending to its members.And whereas the Bank has agreed
                    to grant the * Term Loan /extend Cash Credit facility* to the borrower on certain terms and conditions.(* deleted whichever is not applicable)And whereas the Bank and the borrower are desirous of reducing the agreed terms into writing.Now,
                    therefore, this agreement witnesses as follows:
                </p>
                 <!-- <br/> -->
 <ol class="list">
  <li
    class="fs-14 fw-400 mb-3"
    *ngFor="let item of loanAgreementForm; let i = index"
    [ngClass]="{ 'pt-3': i === 3 }"
    [innerHTML]="item?.point"
  ></li>
</ol>





                <div class="leftRight_border fs-14 fw-400">OR</div>

                <p class="fs-14 fw-400 mb-54">Principal loan along with interest is to be repaid in ------- equal monthly/quarterly/half yearly installments over a period of -------- months/years. In witness where of the parties here to have affixed their signature on the ______________date
                    and the ______________ month and _____________ year first herein above written.</p>

                <div class="d-flex justify-content-evenly mb-100">
                    <span class="fs-14 fw-400">1) FOR THE BORROWER- SHG</span>
                    <span class="fs-14 fw-400">2) FOR THE BANK</span>
                </div>

                <div class="d-flex justify-content-around align-items-center mb-2 border-db br-4 profession_card">
                    <div class="d-flex flex-column align-items-center">
                        <div class="fs-14 fw-400">[Signature of Authorized representatives]</div>
                    </div>
                    <div class="d-flex flex-column align-items-center">
                        <div class="fs-14 fw-400">[Signature of Authorized representative <br> (Office bearers) with office seal]
                        </div>
                    </div>
                    <div class="d-flex flex-column align-items-center">
                        <div class="fs-14 fw-400">(Branch Manager) with office seal</div>
                    </div>
                </div>
                <hr>

                <div class="row">
                    <div class="col-md-9">
                        <h6 class="fs-20 fw-500 text-center">Appraisal Note cum Sanction Order of Bank Branch for financing Self Help Group</h6>
                        <p class="fs-12 fw-400 text-center">redit Linkage (CC/TL) / *Renewal of CC Limit / *Enhancement of CC Limit / *Repeat TL(Strike out which is not applicable)</p>
                    </div>
                </div>

                <div class="fs-14 fw-600 mb-3">Basic Details of SHG:</div>

                <table class="table table-striped">
                    <tbody>
                        <tr>
                            <td>1. Name of the Bank:</td>
                            <td>{{pdfData?.reviewedBankName}}</td>
                        </tr>
                        <tr>
                            <td>2. Name of the Branch:</td>
                            <td>{{ pdfData?.reviewedBranchName }}</td>
                        </tr>
                        <tr>
                            <td>3. Name of the Processing / Inspecting Loan Officer:</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>4. Date of Processing / Inspection:</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>5. Name of the SHG:</td>
                            <td>{{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}})</td>
                        </tr>
                        <tr>
                            <td>6. Address of the SHG:</td>
                            <td>District-{{pdfData?.districtName}}, Grampanchayat-{{pdfData?.grampanchayatName}} , Village-{{pdfData?.villageName}}
                            </td>
                        </tr>
                        <tr>
                            <td>7. Date of formation of the SHG:</td>
                            <td>{{pdfData?.formationDate | date: 'dd/MM/YY' }}</td>
                        </tr>

                        <tr>
                            <td>8. Number of Members in SHG:</td>
                            <td>{{ pdfData?.memberCount }}</td>
                        </tr>
                    </tbody>
                </table>

                <div class="fs-14 fw-600 mb-3">Assessment of SHG:</div>

                <ol class="list">
                    <li class="fs-14 fw-400 mb-3" *ngFor="let item of shgAssessment">{{item?.list}}</li>
                </ol>

                <h6 class="fs-16 fw-600 text-center mb-3">Balance sheet as on {{ pdfData?.incExpDateTo | date: 'dd/MM/YY' }}
                </h6>
                <hr>


                <div class="row">
                    <div class="col-md-6">
                        <h6 class="fs-16 fw-600">Liabilities</h6>
                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <thead>
                                    <tr class="align-middle">
                                        <!-- <th>S.No.</th> -->
                                        <th>Particulars</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="align-middle border-bottom" *ngFor="let item of liabilitiesArr; let i = index;">
                                        <!-- <td>{{ i+1 }}</td> -->
                                        <td>{{ item?.headName }}</td>
                                        <td>
                                            <p>{{ item?.amount }}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h6 class="fs-16 fw-600">Assets</h6>
                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <thead>
                                    <tr class="align-middle">
                                        <!-- <th>S.No.</th> -->
                                        <th>Particulars</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="align-middle border-bottom" *ngFor="let item of assetsArr; let i = index;">
                                        <!-- <td>{{ i+1 }}</td> -->
                                        <td>{{ item?.headName }}</td>
                                        <td>
                                            <p>{{ item?.amount }}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card mb-3 total_card border-0">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="fs-14 fw-400 me-3">Total</div>
                                            <span class="fs-14 fw-400">{{ totalLiabilities }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="fs-14 fw-400 me-3">Total</div>
                                            <span class="fs-14 fw-400">{{ totalAssets }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr>


                <h6 class="fs-14 fw-600 text-center mb-3">Existing Corpus of SHG = Rs. 0 [Total assets - Outstanding Loans (if any)]</h6>
                <hr>

                <h6 class="fs-16 fw-600 text-center mb-3">Assessment of eligibility CC Limit / TL to be sanctioned to the SHG:
                </h6>

                <div class="card rounded-3 border-0 mt-2">
                    <div class="card-body">

                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <thead>
                                    <tr>
                                        <th style="border-right: 1px solid gray;">No. of dose of credit*</th>
                                        <th style="border-right: 1px solid gray;">Eligibility</th>
                                        <th style="border-right: 1px solid gray;">Eligibility Amount (As per RBI Guidelines)</th>
                                        <th>Amount Proposed to be Sanctioned</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr class="border-bottom">

                                        <td style="border-right: 1px solid gray;">Fresh Linkage DP for 1st year/ 1st dose</td>
                                        <td style="border-right: 1px solid gray;">
                                            Existing Corpus : Rs. .......................</td>
                                        <td style="border-right: 1px solid gray;">6 times of the existing corpus or minimum of Rs. 1,50,000/- whichever is higher</td>
                                        <td>
                                            Rs. .............................
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">

                                        <td style="border-right: 1px solid gray;">DP for 2nd year/ 2nd dose</td>
                                        <td style="border-right: 1px solid gray;"></td>
                                        <td style="border-right: 1px solid gray;">8 times of total Corpus or minimum Rs 3,00,000 whichever is higher
                                        </td>
                                        <td>
                                            Rs. .............................
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td style="border-right: 1px solid gray;">DP for 3rd year/ 3rd dose</td>
                                        <td style="border-right: 1px solid gray;"></td>
                                        <td style="border-right: 1px solid gray;">Minimum Rs 6,00,000 or as per Micro Credit Plan</td>
                                        <td>
                                            Rs. .............................
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td style="border-right: 1px solid gray;">DP for 4th year/ 4th dose</td>
                                        <td style="border-right: 1px solid gray;"></td>
                                        <td style="border-right: 1px solid gray;">More than Rs. 6,00,000 or as per Micro Credit Plan</td>
                                        <td>
                                            Rs. .............................
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


                <div class="fs-12 fw-400 mb-3">(*Strike out which is not applicable)</div>
                <div class="fs-14 fw-500 mb-3">Terms of Sanction:</div>

                <div class="fs-14 fw-400 mb-3">Sanctioned a new Cash Credit limit / Renewed / Enhanced the existing Cash Credit limit Rs _______________ Rupees ________________________.only ) under the following terms & conditions:</div>
                <div class="fs-14 fw-400 mb-3">Sanctioned a Term Loan / Renewed / of Rs ________________________ Rupees __________________ .only ) under the following terms & conditions
                </div>

                <div class="fs-14 fw-600 mb-3">(a) Documents to be obtained for Term Loan:</div>
                <ol class="list">
                    <li class="fs-14 fw-400 mb-2">Inter-Se agreement</li>
                    <li class="fs-14 fw-400 mb-2">Articles of loan agreement</li>
                </ol>
                <!-- <br> -->
                <div class="fs-14 fw-600 mb-3">(b) Documents to be obtained for Cash Credit/Demand Loan:</div>
                <ol class="list">
                    <li class="fs-14 fw-400 mb-2">Inter-Se agreement</li>
                    <li class="fs-14 fw-400 mb-2">Demand Promisory Note</li>
                    <li class="fs-14 fw-400 mb-2">Articles of Agreement</li>
                </ol>

                <div class="fs-14 fw-400 mb-3"><span class="fw-600">(c) Purpose of the credit facility:</span> On-lending to the members of the SHG.</div>
                <div class="fs-14 fw-400 mb-3"><span class="fw-600">(d) Rate of
            interest</span> .................................... % p.a. to be calculated on reducing balance method with monthly rest or -------% p.a. upto Rs. 3 lakhs and @----- p.a.on rest amount over Rs. 3 lakhs. The SHG will be eligible to get the
                    benefit of interest subsidy if it fulfil the norms as specified by Government in this regard.</div>
                <div class="fs-14 fw-400 mb-3"><span class="fw-600">(e) Service charge:</span> NIL (Loan to SHG is treated as advance to weaker section).</div>
                <br/>
                <div class="fs-14 fw-400 mb-3"><span class="fw-600">(f) Repayment:</span></div>

                <div class="fs-14 fw-400 mb-2">For Term Loan:</div>

                <ol class="list">
                    <li class="fs-14 fw-400">Principal loan is to be repaid in equal monthly / quarterly / half-yearly instalments of Rs. ----------. Interest debited to the A/C is to be repaid / deposited promptly.
                    </li>
                    <li class="fs-14 fw-400">Principal loan alongwith interest is to be repaid in ------- equal monthly/quarterlyhalf yearly installments of Rs. ------------over a period of -------- months/years.
                    </li>
                    <li class="fs-14 fw-400">Principal loan alongwith interest is to be repaid in ------- equal monthly/quarterlyhalf yearly installments of Rs. ------------over a period of -------- months/years.
                    </li>
                </ol>

                <div class="leftRight_border fs-14 fw-400">OR</div>

                <div class="fs-14 fw-400 mb-95"><span class="fw-600">(g) Review / Evaluation of the C/C A/c will be done
            after 12 months.</span></div>

                <div class="d-flex justify-content-between border-db signature_card br-4">
                    <div class="d-flex flex-column">
                        <div class="fs-14 fw-400 text-uppercase mb-1">Signature of the Processing / Appraising Officer</div>
                        <div class="fs-12 fw-400 color-grey">Date:</div>
                    </div>
                    <div class="d-flex flex-column">
                        <div class="fs-14 fw-400 text-uppercase mb-1">Signature of the Branch Manager (With Office-Seal)
                        </div>
                        <div class="fs-12 fw-400 color-grey">Date:</div>
                    </div>
                </div>

                <p class="fs-14 fw-400 mb-3">We, on behalf of {{pdfData['shgName']}}-({{loanApplicationService.getStateShortName(pdfData.stateId)}}{{pdfData.shgNicCode}})  SHG hereby accept the aforesaid terms & conditions of the above noted CC facility / Term loan sanctioned to
                    our SHG by the above-mentioned Bank Branch.
                </p>
                <ol class="list">
                    <li class="fs-14 fw-400 mb-3"></li>
                    <li class="fs-14 fw-400 mb-3"></li>
                    <li class="fs-14 fw-400 mb-3"></li>
                </ol>

                <div class="fs-14 fw-400 mb-3">(Signature of Authorized representatives of the SHG with office seal)</div>
                <div class="fs-14 fw-400 mb-3">Place:</div>
                <div class="fs-14 fw-400">Date:</div>
                <hr>
                 <!-- <br>
                 <br> -->
                <h6 class="fs-20 fw-500 text-center">Members KYC Details</h6>
               
                <div class="card rounded-3 border-0 mt-2">
                    <div class="card-body">

                        <div class="table-responsive">
                            <table class="table table-borderless">
                                <thead style="text-align: left;">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Member Name</th>
                                        <th>Designation</th>
                                        <th>Document</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr class="border-bottom" *ngFor="let member of membersList; let i = index;">

                                        <td>{{ i + 1 }}</td>
                                        <td>
                                            <img [src]="member?.photo ? member?.photo : '../../../../assets/images/profilePicTemplate.jpg'" alt="N/A" style="width: 30px; height: 30px; border-radius: 50%;" (click)="openDialog(member, 'photo')"> {{member?.memberName}}
                                        </td>
                                        <td>{{member?.leader }}
                                        </td>
                                        <td>
                                            <img [src]="member?.kycImage ? member?.kycImage : '../../../../assets/images/noDocumentFound.jpg'" alt="N/A" style="height: 60px; width: 80px;" (click)="openDialog(member, 'kyc')">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        
    </div>


   
</div>

<!-- <div class="conteiner-bottom">
  <div class="scroll-container-bottom">
    <div class="print_box pointer d-flex align-items-center justify-content-center" mat-icon-button (click)="scrollToUp()">
      <mat-icon>arrow_upward</mat-icon>
    </div>
  </div>
</div> -->
 <div class="d-flex justify-content-between" >
        <button class="btn reject_btn text-white" *ngIf="isSanction" (click)="openRejectDialog(dataFromLoanList)">
      <span><img src="/assets/images/closeIcon-shg.svg" class="img-fluid" alt="Close" /></span>
      Reject</button>
        <div class="d-flex">
            <div class="print_box pointer d-flex align-items-center justify-content-center me-3" (click)="downloadPDF()" matTooltip="Download">
                <img src="/assets/images/download-shg.svg" class="img-fluid" alt="Download" />
            </div>
            <div class="print_box pointer d-flex align-items-center justify-content-center" (click)="printPage()" matTooltip="Print">
                <img src="/assets/images/printIcon-shg.svg" class="img-fluid" alt="Print" />
            </div>

            <button class="btn sanction_Btn text-white text-uppercase br-4" *ngIf="isSanction" (click)="openSanctionDialog(dataFromLoanList)">Sanction the proposal</button>
       
    </div>
    </div>
<div #bottomElement></div>